import React from 'react';
import ReactClass from 'create-react-class';
import Parse from 'parse';
import {Button, FormGroup, FormControl, ControlLabel, Modal, Form, Alert} from 'react-bootstrap';

const DOMAIN = "atappmail.com";

export default ReactClass({

    getInitialState() {
        return {
            code: "",
            name: "",
            showModal: false,
            alert: "",
            mail: "code@" + DOMAIN,
        };
    },

    closeModal(user, info) {
        this.props.close(user, info)
    },

    handleAlertDismiss() {
        this.setState({alert: ""});
    },

    save(event) {
        event.preventDefault();
        // console.log("save()");
        let _this = this;

        let Project = Parse.Object.extend("Project");
        let project = new Project();
        project.set("code", this.state.code);
        project.set("codeLowercase", this.state.code.toLowerCase());
        project.set("name", this.state.name);
        project.save().then(function(){
            _this.closeModal(project);
        }).catch(error => {
            _this.setState({alert: error.message});
        });
        return false;
    },

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
        if (event.target.name === "code"){
            this.setState({mail: event.target.value + "@" + DOMAIN})
        }
    },

    render() {
        return (
            <Modal show={this.props.show} onHide={this.closeModal}>
                <Form onSubmit={this.save}>
                    <Modal.Header closeButton>
                        <Modal.Title>New project</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.alert !== "" &&
                        <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                            <h4>Error</h4>
                            <p>{this.state.alert}</p>
                        </Alert>
                        }

                        <FormGroup
                            controlId="formBasicText"
                        >
                            <ControlLabel>Name</ControlLabel>
                            <FormControl
                                type="text"
                                name="name"
                                value={this.state.name}
                                placeholder="Name"
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup
                            controlId="formBasicText"
                        >
                            <ControlLabel>Code</ControlLabel>
                            <FormControl
                                type="text"
                                name="code"
                                value={this.state.code}
                                placeholder="Code"
                                onChange={this.handleChange}
                            />
                        </FormGroup>

                        <FormGroup
                            controlId="formBasicText"
                        >
                            <ControlLabel>Project e-mail</ControlLabel>
                            <div style={{color:"#aaa"}}>{this.state.mail}</div>
                        </FormGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.closeModal}>Cancel</Button>
                        <Button bsStyle="primary" type="submit">Save</Button>
                    </Modal.Footer>
                </Form>
            </Modal>

        );
    },

});


// WEBPACK FOOTER //
// ./src/ModalProject.js